// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toasted.toasted-primary.warning{background:#f49f36}`, "",{"version":3,"sources":["webpack://./ClientApp/components/userlimit/userlimit.vue.html"],"names":[],"mappings":"AACA,iCACI,kBAAA","sourcesContent":["\n.toasted.toasted-primary.warning {\n    background: #f49f36;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
